import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../context/AuthContext";

export default function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return children || <Outlet />;
}
